var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-layout",
        { attrs: { wrap: "" } },
        [
          _c(
            "v-layout",
            {
              class: {
                column: _vm.$vuetify.breakpoint.mdAndDown,
                row: _vm.$vuetify.breakpoint.lgAndUp,
              },
            },
            [
              _c(
                "v-flex",
                {
                  attrs: {
                    xs12: "",
                    sm12: "",
                    md12: "",
                    lg4: "",
                    "justify-center": "",
                  },
                },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "pb-0",
                          attrs: { flat: "", color: "secondary" },
                        },
                        [_c("h4", [_vm._v("Company Details")])]
                      ),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-list",
                        { attrs: { dense: "" } },
                        [
                          _c(
                            "v-list-item",
                            [
                              _c("v-list-item-content", [_vm._v("Location")]),
                              _vm._v(" "),
                              _c("v-list-item-content", [
                                _vm._v(
                                  "Intershore Chambers, Road Town, Tortola, VG1110, British Virgin Islands"
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item",
                            [
                              _c("v-list-item-content", [
                                _vm._v("Phone | Swiss Number"),
                              ]),
                              _vm._v(" "),
                              _c("v-list-item-content", [
                                _vm._v("+41 225349859"),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item",
                            [
                              _c("v-list-item-content", [
                                _vm._v("Copyrights Website Imprint"),
                              ]),
                              _vm._v(" "),
                              _c("v-list-item-content", [
                                _c(
                                  "a",
                                  {
                                    staticClass: "copyrighted-badge",
                                    attrs: {
                                      title:
                                        "Copyrighted.com Registered & Protected",
                                      target: "_blank",
                                      rel: "noopener noreferrer",
                                      href: "https://www.copyrighted.com/website/C7M74ZizUcH19Gq9",
                                    },
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        alt: "Copyrighted.com Registered & Protected",
                                        border: "0",
                                        width: "125",
                                        height: "25",
                                        srcset:
                                          "https://static.copyrighted.com/badges/125x25/02_2_2x.png" +
                                          " 2x",
                                        src: "https://static.copyrighted.com/badges/125x25/02_2.png",
                                      },
                                    }),
                                  ]
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item",
                            [
                              _c("v-list-item-content", [
                                _vm._v("Copyrights Game Imprint"),
                              ]),
                              _vm._v(" "),
                              _c("v-list-item-content", [
                                _c(
                                  "a",
                                  {
                                    staticClass: "copyrighted-badge",
                                    attrs: {
                                      title:
                                        "Copyrighted.com Registered & Protected",
                                      target: "_blank",
                                      rel: "noopener noreferrer",
                                      href: "https://www.copyrighted.com/work/gn5TI3TX7YTkusGP",
                                    },
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        alt: "Copyrighted.com Registered & Protected",
                                        border: "0",
                                        width: "125",
                                        height: "25",
                                        srcset:
                                          "https://static.copyrighted.com/badges/125x25/02_2_2x.png" +
                                          " 2x",
                                        src: "https://static.copyrighted.com/badges/125x25/02_2.png",
                                      },
                                    }),
                                  ]
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                {
                  attrs: {
                    xs12: "",
                    sm12: "",
                    md12: "",
                    lg8: "",
                    "justify-center": "",
                  },
                },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-app-bar",
                        {
                          attrs: {
                            flat: "",
                            color: "secondary",
                            role: "heading",
                            "aria-level": "1",
                          },
                        },
                        [_c("v-app-bar-title", [_vm._v("Policy")])],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [_vm._v("\n            Introduction\n          ")]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          'It is RedArc Studio Ltd policy to respect your privacy regarding any information we may collect while operating our website. This Privacy Policy applies to www.animemixedworld.com, *.goz.fun, www.animemixedworld.net, *.goz.fun, www.animemixedworld.net (hereinafter, "us", "we", or "www.animemixedworld.com, *.goz.fun, www.animemixedworld.net"). We respect your privacy and are committed to protecting personally identifiable information you may provide us through the Website. We have adopted this privacy policy ("Privacy Policy") to explain what information may be collected on our Website, how we use this information, and under what circumstances we may disclose the information to third parties. This Privacy Policy applies only to information we collect through the Website and does not apply to our collection of information from other sources.'
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "This Privacy Policy, together with the Terms and conditions posted on our Website, set forth the general rules and policies governing your use of our Website. Depending on your activities when visiting our Website, you may be required to agree to additional terms and conditions."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [_vm._v("\n            Website Visitors\n          ")]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "Like most website operators, RedArc Studio Ltd collects non-personally-identifying information of the sort that web browsers and servers typically make available, such as the browser type, language preference, referring site, and the date and time of each visitor request. RedArc Studio Ltd’s purpose in collecting non-personally identifying information is to better understand how RedArc Studio Ltd’s visitors use its website. From time to time, RedArc Studio Ltd may release non-personally-identifying information in the aggregate, e.g., by publishing a report on trends in the usage of its website."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "RedArc Studio Ltd also collects potentially personally-identifying information like Internet Protocol (IP) addresses for logged in users and for users leaving comments on http://www.animemixedworld.com, *.goz.fun, www.animemixedworld.net blog posts. RedArc Studio Ltd only discloses logged in user and commenter IP addresses under the same circumstances that it uses and discloses personally-identifying information as described below."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [
                          _vm._v(
                            "\n            Account Deactivation Procedure\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "\n            The deactivation of an account may be initiated by our company or by the user. If initiated by our company, we will provide a clear and detailed explanation of the reason for deactivation.\n            If initiated by the user, after deactivation of an account, we may retain certain data associated with it for a certain period of time in accordance with our data retention policies.\n            However, users may request the deletion of their data after their account has been deactivated. You may ask us to delete or remove your Personal Data by contacting us at amwgoz@goz.fun. We will respond to your request within a reasonable period of time.\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [
                          _vm._v(
                            "\n            Account Deactivation\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "\n            The deactivation of an account may be initiated by our company or by the user. If initiated by our company, we will provide a clear and detailed explanation of the reason for deactivation.\n            If initiated by the user, after deactivation of an account, we may retain certain data associated with it for a certain period of time in accordance with our data retention policies.\n            However, users may request the deletion of their data after their account has been deactivated. You may ask us to delete or remove your Personal Data by contacting us at amwgoz@goz.fun. We will respond to your request within a reasonable period of time.\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [_vm._v("\n            Ensure of Data\n          ")]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "\n            After deactivation of an account, we may retain certain data associated with it for a certain period of time in accordance with our data retention policies.\n            However, users may request the deletion of their data after their account has been deactivated. You may ask us to delete or remove your Personal Data by contacting us at amwgoz@goz.fun. We will respond to your request within a reasonable period of time.\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [
                          _vm._v(
                            "\n            Request Data Deletion\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "\n            Accordingly, you can request modification or deletion of your information. We will take reasonable steps to verify your identity before granting any such request to prevent unauthorized access.\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [
                          _vm._v(
                            "\n            Account Termination\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "\n            In some cases, user accounts may be terminated without notice, particularly if they violate our terms of service or engage in fraudulent activities. In such cases, users will not be able to access their accounts or retrieve any data associated with them.\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [_vm._v("\n            Appeal Process\n          ")]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "\n            Users who believe that their account was deactivated in error may appeal the decision by contacting our customer support team. We will review the case and provide a response within a reasonable period of time.\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [
                          _vm._v(
                            "\n            Request of Copy of User Data\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "We can provide the user a copy of his/her data, after few steps of verifications to make sure that the user is the owner of the data. Unless we're contacted from high authorities, such as court that they requires the data for specific case."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [
                          _vm._v(
                            "\n            Gathering of Personally-Identifying Information\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "Certain visitors to RedArc Studio Ltd websites choose to interact with RedArc Studio Ltd in ways that require RedArc Studio Ltd to gather personally-identifying information. The amount and type of information that RedArc Studio Ltd gathers depends on the nature of the interaction. For example, we ask visitors who sign up for a blog at http://www.animemixedworld.com, *.goz.fun, www.animemixedworld.net to provide a username and email address."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [_vm._v("\n            Security\n          ")]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "The security of your Personal Information is important to us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Information, we cannot guarantee its absolute security."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [_vm._v("\n            Advertisements\n          ")]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "Ads appearing on our website may be delivered to users by advertising partners, who may set cookies. These cookies allow the ad server to recognize your computer each time they send you an online advertisement to compile information about you or others who use your computer. This information allows ad networks to, among other things, deliver targeted advertisements that they believe will be of most interest to you. This Privacy Policy covers the use of cookies by RedArc Studio Ltd and does not cover the use of cookies by any advertisers."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [
                          _vm._v(
                            "\n            Links To External Sites\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "Our Service may contain links to external sites that are not operated by us. If you click on a third party link, you will be directed to that third party`s site. We strongly advise you to review the Privacy Policy and terms and conditions of every site you visit."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "We have no control over, and assume no responsibility for the content, privacy policies or practices of any third party sites, products or services."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [
                          _vm._v(
                            "\n            Protection of Certain Personally-Identifying Information\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "RedArc Studio Ltd discloses potentially personally-identifying and personally-identifying information only to those of its employees, contractors and affiliated organizations that (i) need to know that information in order to process it on RedArc Studio Ltd behalf or to provide services available at RedArc Studio Ltd’s website, and (ii) that have agreed not to disclose it to others. Some of those employees, contractors and affiliated organizations may be located outside of your home country; by using RedArc Studio Ltd website, you consent to the transfer of such information to them. RedArc Studio Ltd will not rent or sell potentially personally-identifying and personally-identifying information to anyone. Other than to its employees, contractors and affiliated organizations, as described above, RedArc Studio Ltd discloses potentially personally-identifying and personally-identifying information only in response to a subpoena, court order or other governmental request, or when RedArc Studio Ltd believes in good faith that disclosure is reasonably necessary to protect the property or rights of RedArc Studio Ltd, third parties or the public at large."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "If you are a registered user of http://www.animemixedworld.com, *.goz.fun, www.animemixedworld.net and have supplied your email address, RedArc Studio Ltd may occasionally send you an email to tell you about new features, solicit your feedback, or just keep you up to date with what’s going on with RedArc Studio Ltd and our products. We primarily use our blog to communicate this type of information, so we expect to keep this type of email to a minimum. If you send us a request (for example via a support email or via one of our feedback mechanisms), we reserve the right to publish it in order to help us clarify or respond to your request or to help us support other users. RedArc Studio Ltd takes all measures reasonably necessary to protect against the unauthorized access, use, alteration or destruction of potentially personally-identifying and personally-identifying information."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [
                          _vm._v(
                            "\n            Aggregated Statistics\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "RedArc Studio Ltd may collect statistics about the behavior of visitors to its website. RedArc Studio Ltd may display this information publicly or provide it to others. However, RedArc Studio Ltd does not disclose your personally-identifying information."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [
                          _vm._v(
                            "\n            Affiliate Disclosure\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "This site uses affiliate links and does earn a commission from certain links. This does not affect your purchases or the price you may pay."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [_vm._v("\n            Cookies\n          ")]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          'To enrich and perfect your online experience, RedArc Studio Ltd uses "Cookies", similar technologies and services provided by others to display personalized content, appropriate advertising and store your preferences on your computer.'
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "A cookie is a string of information that a website stores on a visitor’s computer, and that the visitor’s browser provides to the website each time the visitor returns. RedArc Studio Ltd uses cookies to help RedArc Studio Ltd identify and track visitors, their usage of http://www.animemixedworld.com, and their website access preferences. RedArc Studio Ltd visitors who do not wish to have cookies placed on their computers should set their browsers to refuse cookies before using RedArc Studio Ltd websites, with the drawback that certain features of RedArc Studio Ltd’s websites may not function properly without the aid of cookies."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "By continuing to navigate our website without changing your cookie settings, you hereby acknowledge and agree to RedArc Studio Ltd use of cookies. We use this for solo-purpose to keep user logged if they close the browser, they can easily restrict this by browser."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [_vm._v("\n            E-commerce\n          ")]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "Those who engage in transactions with RedArc Studio Ltd – by purchasing RedArc Studio Ltd`s services or products, are asked to provide additional information, including as necessary the personal and financial information required to process those transactions. In each case, RedArc Studio Ltd collects such information only insofar as is necessary or appropriate to fulfill the purpose of the visitor’s interaction with RedArc Studio Ltd. RedArc Studio Ltd does not disclose personally-identifying information other than as described below. And visitors can always refuse to supply personally-identifying information, with the caveat that it may prevent them from engaging in certain website-related activities."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [_vm._v("\n            Business Transfers\n          ")]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "If RedArc Studio Ltd, or substantially all of its assets, were acquired, or in the unlikely event that RedArc Studio Ltd goes out of business or enters bankruptcy, user information would be one of the assets that is transferred or acquired by a third party. You acknowledge that such transfers may occur, and that any acquirer of RedArc Studio Ltd may continue to use your personal information as set forth in this policy."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [
                          _vm._v(
                            "\n            Privacy Policy Changes\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "Although most changes are likely to be minor, RedArc Studio Ltd may change its Privacy Policy from time to time, and in RedArc Studio Ltd sole discretion. RedArc Studio Ltd encourages visitors to frequently check this page for any changes to its Privacy Policy. Your continued use of this site after any change in this Privacy Policy will constitute your acceptance of such change."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-app-bar",
                        {
                          staticClass: "font-weight-thin text-uppercase",
                          attrs: {
                            flat: "",
                            color: "primary",
                            role: "heading",
                            "aria-level": "2",
                          },
                        },
                        [_vm._v("\n            3rd Parties\n          ")]
                      ),
                      _vm._v(" "),
                      _c("v-card-text", [
                        _vm._v(
                          "A must of 3rd Parties, we must use in order to operate such a large website and maintainability"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("v-subheader", [
                        _vm._v("We use only few, which are the following:"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-list",
                        { attrs: { dense: "" } },
                        [
                          _c(
                            "v-list-item",
                            [
                              _c(
                                "v-list-item-action",
                                { staticClass: "justify-center" },
                                [_c("v-icon", [_vm._v("fal fa-check")])],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-list-item-content", [
                                _vm._v(
                                  "Google Analytics - Used for gathering users what buttons they press the most or links, for us to re-order the website."
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item",
                            [
                              _c(
                                "v-list-item-action",
                                { staticClass: "justify-center" },
                                [_c("v-icon", [_vm._v("fal fa-check")])],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-list-item-content", [
                                _vm._v(
                                  "Facebook Media Interaction - Used for like, share, embed post"
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item",
                            [
                              _c(
                                "v-list-item-action",
                                { staticClass: "justify-center" },
                                [_c("v-icon", [_vm._v("fal fa-check")])],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-list-item-content", [
                                _vm._v(
                                  "Payment Gateways - Used for payments, we usually use pretty strict gateways such as PayPal"
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item",
                            [
                              _c(
                                "v-list-item-action",
                                { staticClass: "justify-center" },
                                [_c("v-icon", [_vm._v("fal fa-check")])],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-list-item-content", [
                                _vm._v(
                                  "Websites that shared onto our Social Network, we get meta tags such as title, description to show it when someone share a URL"
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-divider"),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }